<template>
  <v-container fluid>
    <v-row class="mb-2">
      <v-col cols="12" lg="3" md="3" sm="6">
        <v-card tile class="kpi-card-link" @click="showVehicleList('day')">
          <v-card-text class="pa-5">
            <div class="d-flex align-center">
              <v-btn class="elevation-0" color="info" fab rounded dark>
                <v-icon>mdi-wallet</v-icon>
              </v-btn>
              <div class="ml-2 mr-1">
                <h2 class="headline font-weight-light">{{ day_departure_count }}</h2>
                <h5 class="subtitle-2 font-weight-regular">昨日发车(查看明细)</h5>
              </div>
              <v-spacer></v-spacer>
              <v-icon size="20" color="grey lighten-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="6">
        <v-card tile class="kpi-card-link" @click="showVehicleList('month')">
          <v-card-text class="pa-5">
            <div class="d-flex align-center">
              <v-btn class="elevation-0" color="warning" fab rounded dark>
                <v-icon>mdi-cart-outline</v-icon>
              </v-btn>
              <div class="ml-2 mr-1">
                <h2 class="headline font-weight-light">{{ month_departure_count }}</h2>
                <h5 class="subtitle-2 font-weight-regular">本月发车(查看明细)</h5>
              </div>
              <v-spacer></v-spacer>
              <v-icon size="20" color="grey lighten-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="6">
        <v-card tile>
          <v-card-text class="pa-5">
            <div class="d-flex align-center">
              <v-btn class="elevation-0" color="deep-purple" fab rounded dark>
                <v-icon>mdi-currency-usd</v-icon>
              </v-btn>
              <div class="ml-2 mr-1">
                <h2 class="headline font-weight-light">￥{{ day_real_freight }}</h2>
                <h5 class="subtitle-2 font-weight-regular">昨日运费</h5>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="6">
        <v-card tile class="kpi-card-clickable" @click="showmonthfreight()">
          <v-card-text class="pa-5">
            <div class="d-flex align-center">
              <v-btn class="elevation-0" color="error" fab rounded dark>
                <v-icon>mdi-cash-multiple</v-icon>
              </v-btn>
              <div class="ml-2 mr-1">
                <h2 class="headline font-weight-light">￥{{ month_real_freight }}</h2>
                <h5 class="subtitle-2 font-weight-regular">月运费(查看明细)</h5>
              </div>
              <v-spacer></v-spacer>
              <v-icon size="20" color="grey lighten-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <a-tabs v-model="tab" @change="changetab()">
      <a-tab-pane v-for="item in tabs" :key="item.value" :tab="item.text"></a-tab-pane>
      <a-range-picker slot="tabBarExtraContent" v-model="date_range" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
        :allowClear="false" @change="getchartdata()"></a-range-picker>
    </a-tabs>
    <v-row>
      <v-col cols="12">
        <div style="min-height: 315px; width: 100%; position: relative">
          <apexchart v-if="series.length > 0" type="line" height="315" :options="chartOptions" :series="series" />
        </div>
      </v-col>
    </v-row>
    <v-card tile>
      <v-row>
        <v-col cols="12" sm="5" lg="5">
          <div class="d-flex align-center justify-space-between" style="margin-bottom: 8px;">
            <h4 class="t-title" style="margin: 0;">发车情况(实时读取)</h4>
            <div class="d-flex align-center">
              <!-- 发车数据基准日期：默认昨天，改变后重新加载发车数据/发车详情 -->
              <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text small color="primary" class="px-2 mr-1" v-bind="attrs" v-on="on">
                    <v-icon size="16" class="mr-1">mdi-calendar</v-icon>{{ date }}
                  </v-btn>
                </template>
                <v-date-picker v-model="date" no-title scrollable locale="zh-cn" :max="maxDate"
                  @change="dateMenu = false; getdata()"></v-date-picker>
              </v-menu>
              <v-btn text color="primary" class="px-2" @click="openDispatchDetail()">
                查看详情
              </v-btn>
            </div>
          </div>
          <v-data-table v-if="projectdata.list1" :headers="headers" :items="projectdata.list1"
            :items-per-page="projectdata.list1.length" class="elevation-1" no-data-text="无数据" hide-default-footer
            disable-sort>
            <template v-slot:item.dispatch_post_office="{ item }">
              <span :class="{
                'text-h6 error--text': item.dispatch_post_office === '合计'
              }">{{ item.dispatch_post_office }}</span>
            </template>
            <template v-slot:item.day_departure_count="{ item }">
              <v-btn v-if="item.day_departure_count > 0" text
                :color="item.dispatch_post_office === '合计' ? 'error' : 'primary'" @click="showdetail1(item)">
                {{ item.day_departure_count }}
              </v-btn>
              <span v-else>{{ item.day_departure_count }}</span>
            </template>
            <template v-slot:item.month_departure_count="{ item }">
              <v-btn v-if="item.month_departure_count > 0" text
                :color="item.dispatch_post_office === '合计' ? 'error' : 'primary'" @click="showdetail2(item)">
                {{ item.month_departure_count }}
              </v-btn>
              <span v-else>{{ item.month_departure_count }}</span>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" sm="7" lg="7">
          <h4 class="t-title">运行情况(实时读取)</h4>
          <v-data-table v-if="projectdata.list2" :headers="headers2" :items="projectdata.list2"
            :items-per-page="projectdata.list2.length" class="elevation-1" no-data-text="无数据" hide-default-footer
            disable-sort>
            <template v-slot:item.delay_count="{ item }">
              <v-btn v-if="item.delay_count > 0" text color="primary" @click="showdetail3(item)">
                {{ item.delay_count }}
              </v-btn>
              <span v-else>{{ item.delay_count }}</span>
            </template>
            <template v-slot:item.nogps_count="{ item }">
              <v-btn v-if="item.nogps_count > 0" text color="primary" @click="showdetail4(item)">
                {{ item.nogps_count }}
              </v-btn>
              <span v-else>{{ item.nogps_count }}</span>
            </template>
          </v-data-table>
          <h4 class="t-title mt-2">车辆使用情况（百分比指昨日发车趟次/昨日总发车趟次）</h4>
          <v-data-table v-if="projectdata.list4" :headers="headers4" :items="projectdata.list4"
            :items-per-page="projectdata.list4.length" class="elevation-1" no-data-text="无数据" hide-default-footer
            disable-sort>
            <template v-slot:item.own_count1="{ item }">
              <a-space>
                <span>
                  {{ item.own_vcount1 }}/{{ item.own_count1 }}{{ item.own_rate1 > 0 ? `(${item.own_rate1}%)` : '' }}
                </span>
                <div class="d-flex flex-column">
                  <span v-if="item.own_1_section_1 > 0">一：{{ item.own_1_section_1 }}</span>
                  <span v-if="item.own_1_section_2 > 0">二：{{ item.own_1_section_2 }}</span>
                  <span v-if="item.own_1_section_3 > 0">三：{{ item.own_1_section_3 }}</span>
                  <span v-if="item.own_1_section_4 > 0">四：{{ item.own_1_section_4 }}</span>
                  <span v-if="item.own_1_section_5 > 0">五：{{ item.own_1_section_5 }}</span>
                  <span v-if="item.own_1_section_6 > 0">六：{{ item.own_1_section_6 }}</span>
                </div>
              </a-space>
            </template>
            <template v-slot:item.own_count2="{ item }">
              <a-space>
                <span>
                  {{ item.own_vcount2 }}/{{ item.own_count2 }}{{ item.own_rate2 > 0 ? `(${item.own_rate2}%)` : '' }}
                </span>
                <div class="d-flex flex-column">
                  <span v-if="item.own_2_section_1 > 0">一：{{ item.own_2_section_1 }}</span>
                  <span v-if="item.own_2_section_2 > 0">二：{{ item.own_2_section_2 }}</span>
                  <span v-if="item.own_2_section_3 > 0">三：{{ item.own_2_section_3 }}</span>
                  <span v-if="item.own_2_section_4 > 0">四：{{ item.own_2_section_4 }}</span>
                  <span v-if="item.own_2_section_5 > 0">五：{{ item.own_2_section_5 }}</span>
                  <span v-if="item.own_2_section_6 > 0">六：{{ item.own_2_section_6 }}</span>
                </div>
              </a-space>
            </template>
            <template v-slot:item.own_count3="{ item }">
              <a-space>
                <span>
                  {{ item.own_vcount3 }}/{{ item.own_count3 }}{{ item.own_rate3 > 0 ? `(${item.own_rate3}%)` : '' }}
                </span>
                <div class="d-flex flex-column">
                  <span v-if="item.own_3_section_1 > 0">一：{{ item.own_3_section_1 }}</span>
                  <span v-if="item.own_3_section_2 > 0">二：{{ item.own_3_section_2 }}</span>
                  <span v-if="item.own_3_section_3 > 0">三：{{ item.own_3_section_3 }}</span>
                  <span v-if="item.own_3_section_4 > 0">四：{{ item.own_3_section_4 }}</span>
                  <span v-if="item.own_3_section_5 > 0">五：{{ item.own_3_section_5 }}</span>
                  <span v-if="item.own_3_section_6 > 0">六：{{ item.own_3_section_6 }}</span>
                </div>
              </a-space>
            </template>
          </v-data-table>
          <h4 class="t-title mt-2">发车数据</h4>
          <v-data-table dense :headers="projectdata.departure_headers" :items="projectdata.departure_data"
            class="elevation-1" no-data-text="无数据" hide-default-footer disable-sort>
            <template v-slot:item.count1="{ item }">
              <p>{{ item.count1 }}</p>
            </template>
            <template v-slot:item.count2="{ item }">
              <p>{{ item.count2 }}</p>
            </template>
            <template v-slot:item.count3="{ item }">
              <p>{{ item.count3 }}</p>
            </template>
            <template v-slot:item.count4="{ item }">
              <p>{{ item.count4 }}</p>
            </template>
            <template v-slot:item.count5="{ item }">
              <p>{{ item.count5 }}</p>
            </template>
            <template v-slot:item.count6="{ item }">
              <p>{{ item.count6 }}</p>
            </template>
            <template v-slot:item.count7="{ item }">
              <p>{{ item.count7 }}</p>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="detail_model" max-width="960px">
      <v-card tile>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          发车详情
          <v-icon @click="() => detail_model = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a-table size="small" :columns="detail_header" :data-source="detail_list" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ x: detail_width, y: 600 }">
            <template slot="line" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.line }}</span>
            </template>
            <template slot="weight_5" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_5 }}</span>
            </template>
            <template slot="weight_8" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_8 }}</span>
            </template>
            <template slot="weight_12" slot-scope="text, item">
              <p :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_12 }}</p>
              <p :class="{ 'text-h6 error--text': item.line === '合计' }" v-if="item.rate_12">{{ item.rate_12 }}%</p>
            </template>
            <template slot="weight_15" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_15 }}</span>
            </template>
            <template slot="weight_20" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_20 }}</span>
            </template>
            <template slot="weight_25" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_25 }}</span>
            </template>
            <template slot="weight_30" slot-scope="text, item">
              <p :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_30 }}</p>
              <p :class="{ 'text-h6 error--text': item.line === '合计' }" v-if="item.rate_30">{{ item.rate_30 }}%</p>
            </template>
            <template slot="weight_35" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_35 }}</span>
            </template>
            <template slot="weight_40" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_40 }}</span>
            </template>
            <template slot="weight_undefined" slot-scope="text, item">
              <span :class="{ 'text-h6 error--text': item.line === '合计' }">{{ item.weight_undefined }}</span>
            </template>
            <template slot="total" slot-scope="text, item">
              <span class="text-h6 error--text">{{ item.total }}</span>
            </template>
            <!-- 任务占比(单程/往返) -->
            <template slot="transport_kind" slot-scope="text, item">
              <div :class="{ 'text-h6 error--text': item.line === '合计' }">
                <p>单程: {{ item.transport_kind1 }} ({{ item.transport_rate1 + '%' }})</p>
                <p>往返: {{ item.transport_kind2 }} ({{ item.transport_rate2 + '%' }})</p>
              </div>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 发车详情弹框：全屏展示"线路 × 日期"发车次明细（按图示：单数字） -->
    <v-dialog v-model="dispatchDetailOpen" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable
      @keydown.esc="dispatchDetailOpen = false">
      <v-card tile>
        <v-card-title class="d-flex align-center justify-space-between px-4 py-3"
          style="background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%); color: #fff;">
          <div class="d-flex align-center">
            <v-icon dark class="mr-2">mdi-truck-fast</v-icon>
            <span class="font-weight-bold" style="font-size: 16px;">发车情况 - 每日明细</span>
            <span class="ml-3" style="font-size: 12px; opacity: 0.85;">
              （{{ daySlotNames.length }} 天 / {{ mockLineCount }}条线路）
            </span>
            <span class="ml-3" style="font-size: 12px; opacity: 0.75;">（单元格：12吨|30吨车次）</span>
          </div>
          <v-btn icon dark small @click="dispatchDetailOpen = false" title="关闭 (ESC)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="background: #fafafa;">
          <a-table size="small" bordered :columns="dispatchDetailHeaders" :data-source="dispatchDetailRows"
            :pagination="false" :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 'max-content', y: 'calc(100vh - 160px)' }"
            :row-class-name="(record) => record._isSummary ? 'summary-row' : ''" row-key="_id"
            class="dispatch-detail-table">
            <template slot="name" slot-scope="text, record">
              <span :class="{
                'text-h6 font-weight-bold': record._isSummary,
                'dispatch-cell-name': !record._isSummary
              }">
                {{ text }}
              </span>
            </template>
            <template v-for="col in daySlotNames" :slot="col.slot" slot-scope="text, record">
              <div :key="col.slot" class="dispatch-cell">
                <span v-if="record._isSummary" class="dispatch-cell-summary">{{ text }}</span>
                <span v-else-if="text !== '' && text !== '-' && text !== null && text !== undefined"
                  class="dispatch-cell-num">{{ text }}</span>
                <span v-else class="dispatch-cell-empty">-</span>
              </div>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 本月运费每日明细:点击"本月运费"卡片触发 -->
    <v-dialog v-model="monthfreightmodel" max-width="990px" @keydown.esc="monthfreightmodel = false">
      <v-card tile>
        <v-card-title class="d-flex align-center justify-space-between pa-2 text-subtitle-1 mb-4"
          style="background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%); color: #fff;">
          <div class="d-flex align-center">
            <v-icon dark class="mr-2">mdi-cash-multiple</v-icon>
            <span class="font-weight-bold">本月运费 - 每日明细</span>
            <!-- <span class="ml-3" style="font-size: 12px; opacity: 0.85;">
              （{{ monthfreightdaycount }} 天 / 一干 + 二干(1-6标段) / 收入·成本·利润）
            </span> -->
          </div>
          <v-icon @click="monthfreightmodel = false" dark title="关闭 (ESC)">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-0">
          <a-table size="small" bordered :columns="monthfreightheaders" :data-source="monthfreightlist"
            :pagination="false" :locale="{ emptyText: '暂无数据' }" row-key="_id" :scroll="{ x: 990, y: 420 }"
            :row-class-name="monthFreightRowClass" class="month-detail-table">
            <!-- 日期 -->
            <template slot="date" slot-scope="text, record">
              <span :class="{
                'dispatch-cell-name': true,
                'text-h6': record._isTotal
              }">{{ record.date }}</span>
            </template>
            <!-- 各标段单元格：收入/成本/利润 三段显示 -->
            <template v-for="sec in freightSections" :slot="sec.key" slot-scope="text, record">
              <div :key="sec.key" :class="{ 'text-h6': record._isTotal }">
                <template v-if="record.section">
                  <span class="freight-cell freight-income">{{ record[sec.key].fincome }}</span>
                  <span class="freight-cell freight-cost">{{ record[sec.key].fcost }}</span>
                  <span class="freight-cell" :class="{
                    'text-positive': record[sec.key].profit >= 0,
                    'text-negative': record[sec.key].profit < 0
                  }">{{ record[sec.key].profit >= 0 ? '+' : '' }}{{ record[sec.key].fprofit }}</span>
                </template>
                <template v-else>
                  <span v-if="sec.key === 'income'" class="freight-cell text-positive">{{ record.fincome }}</span>
                  <span v-if="sec.key === 'cost'" class="freight-cell text-negative">{{ record.fcost }}</span>
                  <span v-if="sec.key === 'profit'" class="freight-cell" :class="{
                    'text-positive': record.profit >= 0,
                    'text-negative': record.profit < 0
                  }">{{ record.profit >= 0 ? '+' : '' }}{{ record.fprofit }}</span>
                </template>
              </div>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 发车车辆明细:点击"昨日发车/本月发车"卡片触发（昨日=昨日全部发车车辆，本月=截止昨日的本月发车车辆） -->
    <!-- 注意:当前为前端固定演示数据 vehicleMockData，后端接口写好后在 showVehicleList 内切换即可 -->
    <!-- 表格样式复用"发车情况-每日明细"弹框的 dispatch-detail-table 同款规范 -->
    <v-dialog v-model="vehiclemodel" max-width="900px" @keydown.esc="vehiclemodel = false">
      <v-card tile>
        <v-card-title class="d-flex align-center justify-space-between px-4 py-3"
          style="background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%); color: #fff;">
          <div class="d-flex align-center">
            <v-icon dark class="mr-2">mdi-truck</v-icon>
            <span class="font-weight-bold" style="font-size: 16px;">{{ vehicletitle }}</span>
            <span class="ml-3" style="font-size: 12px; opacity: 0.85;">
              （共 {{ vehiclecount }} 辆车 / 里程单位km / 利润单位元）
            </span>
          </div>
          <v-btn icon dark small @click="vehiclemodel = false" title="关闭 (ESC)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="background: #fafafa;">
          <a-table size="small" bordered :columns="vehicleheaders" :data-source="vehiclelist" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" row-key="_id" :scroll="{ y: 'calc(100vh - 180px)' }"
            :row-class-name="vehicleRowClass" class="dispatch-detail-table">
            <!-- 序号 -->
            <template slot="index" slot-scope="text, record">
              <div class="dispatch-cell">
                <span v-if="!record._isTotal" class="dispatch-cell-num">{{ record._seq }}</span>
              </div>
            </template>
            <!-- 车辆(车牌) -->
            <template slot="vehicle_number" slot-scope="text, record">
              <span :class="{
                'text-h6 font-weight-bold': record._isTotal,
                'dispatch-cell-name': !record._isTotal
              }">{{ record.vehicle_number }}</span>
            </template>
            <!-- 里程 -->
            <template slot="mileage" slot-scope="text, record">
              <div class="dispatch-cell">
                <span v-if="record._isTotal" class="dispatch-cell-summary">{{ formatMileage(record.mileage) }}</span>
                <span v-else class="dispatch-cell-num">{{ formatMileage(record.mileage) }}</span>
              </div>
            </template>
            <!-- 利润（正绿负红） -->
            <template slot="profit" slot-scope="text, record">
              <div class="dispatch-cell">
                <span :class="{
                  'dispatch-cell-summary': record._isTotal,
                  'dispatch-cell-num': !record._isTotal,
                  'text-positive': record.profit >= 0,
                  'text-negative': record.profit < 0
                }">{{ record.profit >= 0 ? '+' : '' }}{{ formatProfit(record.profit) }}</span>
              </div>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import Vue from "vue";
import { Empty } from "vant";
Vue.use(Empty);
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
  name: "Daily",
  data() {
    return {
      tab: 'henan2',
      tabs: [
        { value: 'henan2', text: '二干' },
        { value: 'henan1', text: '一干' },
      ],
      date: this.$moment().subtract(1, 'day').format("YYYY-MM-DD"),//发车数据基准日期（默认昨天）
      dateMenu: false,//发车数据日期选择器弹层开关
      date_range: [
        this.$dateFormat(Date.now() - 7 * 24 * 60 * 60 * 1000),
        this.$dateFormat(Date.now() - 1 * 24 * 60 * 60 * 1000),
      ],
      desc: '',
      day_departure_count: 0,
      month_departure_count: 0,
      day_real_freight: "0.00",
      month_real_freight: "0.00",
      headers2: [
        { text: "#", value: "title", align: "center", width: 80 },
        { text: "总到达", value: "arrival_count", align: "center", width: 100 },
        { text: "无进(出)围栏数", value: "nogps_count", align: "center", width: 120 },
        { text: "GPS采集率", value: "gps_rate", align: "center", width: 120 },
        { text: "晚点", value: "delay_count", align: "center", width: 80 },
        { text: "准点率", value: "right_rate", align: "center", width: 100 },
      ],
      headers3: [
        { text: "#", value: "title", align: "center", width: 80 },
        { text: "发车", value: "departure_count", align: "center", width: 100 },
        { text: "到达", value: "arrival_count", align: "center", width: 100 },
        { text: "预估收入", value: "_freight1", align: "center", width: 150 },
        { text: "成本", value: "_freight2", align: "center", width: 150 },
        { text: "利润", value: "_profit", align: "center", width: 120 },
        { text: "利润率", value: "rate", align: "center", width: 100 },
      ],
      headers4: [
        { text: "#", value: "title", align: "center", width: 80 },
        { text: "自有车", value: "own_count1", align: "center", width: 300 },
        { text: "包车", value: "own_count3", align: "center", width: 300 },
        { text: "临调", value: "own_count2", align: "center", width: 300 },
      ],
      projectdata: this.initdata(),
      detail_header: [],
      detail_list: [],
      detail_model: false,
      // 发车详情弹框
      dispatchDetailOpen: false,
      dispatchDetailHeaders: [],
      dispatchDetailRows: [],
      mockLineCount: 0,
      chartdata: {
        title: "",
        categorys: [],
        data1: [],
        data2: [],
        data_1_2: [],
        data3: [],
      },
      // 本月运费每日明细弹框
      monthfreightmodel: false,
      // 标段列定义：key 对应每行数据字段，title 为表头
      freightSections2: [
        { key: 's1', title: '1标段' },
        // { key: 's2', title: '2标段' },
        // { key: 's3', title: '3标段' },
        { key: 's4', title: '4标段' },
        // { key: 's5', title: '标段' },
        // { key: 's6', title: '标段' },
        { key: 'day_total', title: '当月小计' },
      ],
      freightSections1: [
        { key: 'income', title: '运费收入' },
        { key: 'cost', title: '运费支出' },
        { key: 'profit', title: '利润' },
      ],
      monthfreightlist: [],
      // 本月运费明细天数
      monthfreightdaycount: 0,
      // 发车车辆明细弹框（昨日发车/本月发车共用）
      vehiclemodel: false,
      vehicletitle: "",
      vehiclelist: [],
      vehiclecount: 0,
      vehicleheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, align: "center", width: 70 },
        { title: "车辆(车牌)", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, align: "center" },
        { title: "里程(km)", dataIndex: "mileage", scopedSlots: { customRender: "mileage" }, align: "center", width: 150 },
        { title: "利润(元)", dataIndex: "profit", scopedSlots: { customRender: "profit" }, align: "center", width: 160 },
      ],
      vehicleMockData: {
        day: [
          { vehicle_number: "豫AD8762", mileage: 326.5, profit: 2856.8 },
          { vehicle_number: "豫AD5310", mileage: 412.0, profit: 1980.5 },
          { vehicle_number: "豫AD9021", mileage: 268.3, profit: 1245.0 },
          { vehicle_number: "豫AD6678", mileage: 350.6, profit: 560.33 },
          { vehicle_number: "豫AD2345", mileage: 198.4, profit: -186.2 },
        ],
        month: [
          { vehicle_number: "豫AD5310", mileage: 6820.5, profit: 38650.0 },
          { vehicle_number: "豫AD8762", mileage: 5980.2, profit: 31200.66 },
          { vehicle_number: "豫AD9021", mileage: 4560.8, profit: 22480.3 },
          { vehicle_number: "豫AD1120", mileage: 4210.0, profit: 18360.9 },
          { vehicle_number: "豫AD6678", mileage: 3890.4, profit: 9650.25 },
          { vehicle_number: "豫AD7788", mileage: 3120.6, profit: 4200.0 },
          { vehicle_number: "豫AD3356", mileage: 2450.3, profit: -820.5 },
          { vehicle_number: "豫AD2345", mileage: 1860.7, profit: -1560.88 },
        ],
      },
    };
  },
  computed: {
    // 日期选择器最大可选日期：昨天（当天无数据，最早只能查前一天）
    maxDate() {
      return this.$moment().subtract(1, 'day').format('YYYY-MM-DD');
    },
    // 发车情况表头："昨日"列动态显示所选基准日期（MM-DD）
    headers() {
      return [
        { text: "邮局", value: "dispatch_post_office", align: "center", width: 100 },
        { text: this.date ? this.$moment(this.date).format('MM-DD') : "昨日", value: "day_departure_count", align: "center", width: 150 },
        { text: "本月", value: "month_departure_count", align: "center", width: 150 },
      ];
    },
    freightSections() {
      if (this.tab === 'henan1') return this.freightSections1;
      if (this.tab === 'henan2') return this.freightSections2;
      return [];
    },
    // 表头：日期 + 各标段（单元格内 收入/成本/利润 三段），宽度由 table-layout:fixed 均分自适应
    monthfreightheaders() {
      if (this.tab === 'henan1') {
        return [
          { title: '日期', dataIndex: 'date', align: 'center', scopedSlots: { customRender: 'date' } },
          ...this.freightSections1.map((sec) => ({
            title: sec.title,
            dataIndex: sec.key,
            align: 'center',
            scopedSlots: { customRender: sec.key },
          })),
        ];
      }
      if (this.tab === 'henan2') {
        return [
          { title: '日期', dataIndex: 'date', align: 'center', scopedSlots: { customRender: 'date' } },
          ...this.freightSections2.map((sec) => ({
            title: sec.title,
            dataIndex: sec.key,
            align: 'center',
            scopedSlots: { customRender: sec.key },
          })),
        ];
      }
      return [];
    },
    detail_width() {
      return _.reduce(this.detail_header, (a, b) => a + (b.width || 300), 0);
    },
    // 每日列的 slot 名称集合（用于模板 v-for）
    daySlotNames() {
      return this.dispatchDetailHeaders
        .filter((h) => h.dataIndex && h.dataIndex.startsWith('day_'))
        .map((h) => ({ slot: h.dataIndex, date: h.dataIndex.replace('day_', '') }));
    },
    series() {
      return [
        {
          name: '收入',
          type: 'column',
          data: this.chartdata.data1//<!--!替换
        },
        {
          name: '成本',
          type: 'column',
          data: this.chartdata.data2//<!--!替换
        },
        {
          name: '利润',
          type: 'column',
          data: this.chartdata.data_1_2,
        },
        {
          name: '发车数',
          type: 'line',
          data: this.chartdata.data3,//<!--!替换
        }
      ];
    },
    chartOptions() {
      return {
        chart: {
          height: 315, type: 'line', stacked: false,
          zoom: { enabled: false },
        },
        dataLabels: { enabled: false },
        stroke: {
          width: [1, 1, 1, 4],
        },
        title: {
          text: this.chartdata.title,//<!--! 标题
          align: 'left',
        },
        // plotOptions: {
        //   bar: {
        //     horizontal: false,
        //     // columnWidth: '35%',
        //     borderRadius: 5,
        //     borderRadiusApplication: 'end',
        //   },
        // },
        colors: [function ({ value, seriesIndex, w }) {
          if (seriesIndex === 0) return '#008FFB';
          if (seriesIndex === 1) return '#00E396';
          if (seriesIndex === 2) {
            if (value > 0) {
              return '#2E7D32'
            }
            else {
              return '#D9534F'
            }
          }
          if (seriesIndex === 3) return '#FEB019';
        }],
        xaxis: {
          categories: this.chartdata.categorys,//<!--!替换
        },
        yaxis: [
          {
            seriesName: '收入',
            max: this.chartdata.max1,
            min: this.chartdata.min1,
            axisTicks: { show: true, },
            axisBorder: { show: true, color: '#008FFB' },
            labels: {
              style: { colors: '#008FFB', },
              formatter: (val) => this.$utils.formatMoney(val, 2, ''),
            },
            title: {
              text: "收入",
              style: { color: '#008FFB', }
            },
            tooltip: { enabled: true }
          },
          {
            seriesName: '成本',
            max: this.chartdata.max2,
            min: this.chartdata.min2,
            // opposite: true,
            axisTicks: { show: true, },
            axisBorder: { show: true, color: '#00E396' },
            labels: {
              style: { colors: '#00E396', },
              formatter: (val) => this.$utils.formatMoney(val, 2, ''),
            },
            title: {
              text: "成本",
              style: { color: '#00E396', }
            },
          },
          {
            seriesName: '利润',
            max: this.chartdata.max_1_2,
            min: this.chartdata.min_1_2,
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#2E7D32' },
            labels: {
              style: { colors: '#2E7D32' },
              formatter: (val) => this.$utils.formatMoney(val, 2, ''),
            },
            title: {
              text: '利润',
              style: { color: '#2E7D32' }
            },
          },
          {
            seriesName: '发车数',
            max: this.chartdata.max3,
            min: this.chartdata.min3,
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#FEB019' },
            labels: {
              style: { colors: '#FEB019' },
              formatter: (val) => Math.round(Number(val || 0)).toLocaleString('zh-CN'),
            },
            title: {
              text: '发车数',
              style: { color: '#FEB019' },
            },
          },
        ],
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          },
        },
        legend: { horizontalAlign: 'center', offsetX: 40 }
      };
    },
  },
  watch: {},
  mounted() {
    console.log("daily-mounted");
  },
  activated() {
    this.date = this.$moment().subtract(1, 'day').format("YYYY-MM-DD");//默认昨天
    this.getdata();
    this.getchartdata();
  },
  methods: {
    //tab切换
    changetab() {
      this.getdata();
      this.getchartdata();
    },
    getdata() {
      this.monthfreightlist = [];
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/dailydata", {
        date: this.date,
        province: this.tab
      }).then((res) => {
        // console.log(res);
        this.desc = res.data.desc;
        this.day_departure_count = res.data.day_departure_count;
        this.month_departure_count = res.data.month_departure_count;
        this.day_real_freight = res.data.day_real_freight;
        this.month_real_freight = res.data.month_real_freight;
        this.projectdata = res.data.projectdata;
        this.$toast.clear();
      });
    },
    getchartdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/financial", {
        date_range: this.date_range,
        province: this.tab
      }).then((res) => {
        this.chartdata = res.data.result[0];
        this.$toast.clear();
      });
    },
    // 打开"本月运费每日明细"弹框
    showmonthfreight() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/showmonthfreight", {
        date: this.date,
        province: this.tab,
      }).then((res) => {
        console.log(res);
        this.$toast.clear();
        if (res.code === 0) {
          this.monthfreightdaycount = res.data.list.length - 1;
          this.monthfreightlist = res.data.list;
          this.monthfreightmodel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
    // 本月运费明细表格行样式：合计行高亮
    monthFreightRowClass(record) {
      return record._isTotal ? 'summary-row' : '';
    },
    showVehicleList(type) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/showvehiclelist", {
        date: this.date,
        province: this.tab,
        type,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.makeVehicleList((res.data && res.data.list) || [], type);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch(() => {
        this.$toast.clear();
      });
    },
    // 组装车辆明细表格（按利润倒序，首行合计）
    makeVehicleList(list, type) {
      const rows = list.map((n, i) => ({
        _id: n.vehicle_number || `v_${i}`,
        vehicle_number: n.vehicle_number || "",
        mileage: Number(n.mileage) || 0,
        profit: Number(n.profit) || 0,
      })).sort((a, b) => b.profit - a.profit)
        .map((n, i) => ({ ...n, _seq: i + 1 }));
      this.vehiclecount = rows.length;
      this.vehicletitle = type === "month" ? "本月发车 - 车辆明细(截止昨日)" : "昨日发车 - 车辆明细";
      if (rows.length === 0) {
        this.vehiclelist = [];
      }
      else {
        const total = rows.reduce((acc, r) => {
          acc.mileage += r.mileage;
          acc.profit += r.profit;
          return acc;
        }, { mileage: 0, profit: 0 });
        this.vehiclelist = [
          { _id: "total", _isTotal: true, vehicle_number: "合计", mileage: total.mileage, profit: total.profit },
          ...rows,
        ];
      }
      this.vehiclemodel = true;
    },
    // 车辆明细表格行样式：合计行高亮
    vehicleRowClass(record) {
      return record._isTotal ? "summary-row" : "";
    },
    // 里程格式化：千分位 + 2 位小数
    formatMileage(val) {
      return (Number(val) || 0).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    // 利润格式化：千分位 + 2 位小数（正负号在模板中处理）
    formatProfit(val) {
      return (Number(val) || 0).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    initdata() {
      return {
        day_departure_count: 0,
        month_departure_count: 0,
        day_real_freight: 0,
        month_real_freight: 0,
        list1: [],
        list2: [],
        list4: [],
        departure_headers: [],
        departure_data: [],
      };
    },
    makedetaillist(list) {
      let _total = 0;
      let weight_5 = '';
      let weight_8 = '';
      let weight_12 = '';
      let weight_15 = '';
      let weight_20 = '';
      let weight_25 = '';
      let weight_30 = '';
      let weight_35 = '';
      let weight_40 = '';
      let weight_undefined = '';
      let total_ = 0;
      let transport_kind1 = '';
      let transport_kind2 = '';
      let detail_list = list.map(n => {
        let total1 = _.reduce(_.values(n.data), (a, b) => a + b, 0);
        _total += total1;
        if (n.data['5']) {
          if (weight_5 === '') weight_5 = 0;
          weight_5 += n.data['5'];
        }
        if (n.data['8']) {
          if (weight_8 === '') weight_8 = 0;
          weight_8 += n.data['8'];
        }
        if (n.data['12']) {
          if (weight_12 === '') weight_12 = 0;
          weight_12 += n.data['12'];
        }
        if (n.data['15']) {
          if (weight_15 === '') weight_15 = 0;
          weight_15 += n.data['15'];
        }
        if (n.data['20']) {
          if (weight_20 === '') weight_20 = 0;
          weight_20 += n.data['20'];
        }
        if (n.data['25']) {
          if (weight_25 === '') weight_25 = 0;
          weight_25 += n.data['25'];
        }
        if (n.data['30']) {
          if (weight_30 === '') weight_30 = 0;
          weight_30 += n.data['30'];
        }
        if (n.data['35']) {
          if (weight_35 === '') weight_35 = 0;
          weight_35 += n.data['35'];
        }
        if (n.data['40']) {
          if (weight_40 === '') weight_40 = 0;
          weight_40 += n.data['40'];
        }
        if (n.data['undefined']) {
          if (weight_undefined === '') weight_undefined = 0;
          weight_undefined += n.data['undefined'];
        }
        let total2 = _.reduce(_.values(n.data2), (a, b) => a + b, 0);
        total_ += total2;
        if (n.data2['单程']) {
          if (transport_kind1 === '') transport_kind1 = 0;
          transport_kind1 += n.data2['单程'];
        }
        if (n.data2['往返']) {
          if (transport_kind2 === '') transport_kind2 = 0;
          transport_kind2 += n.data2['往返'];
        }
        return {
          ...n,
          weight_5: n.data['5'] || '',
          weight_8: n.data['8'] || '',
          weight_12: n.data['12'] || '',
          rate_12: n.data['12'] ? this.$d(this.$d(n.data['12']).div(total1).times(100).toFixed(2)).toString() : '',
          weight_15: n.data['15'] || '',
          weight_20: n.data['20'] || '',
          weight_25: n.data['25'] || '',
          weight_30: n.data['30'] || '',
          rate_30: n.data['30'] ? this.$d(this.$d(n.data['30']).div(total1).times(100).toFixed(2)).toString() : '',
          weight_35: n.data['35'] || '',
          weight_40: n.data['40'] || '',
          weight_undefined: n.data['undefined'] || '',
          transport_kind1: n.data2['单程'] || 0,
          transport_rate1: this.$d(this.$d(n.data2['单程']).div(total2).times(100).toFixed(2)).toString(),
          transport_kind2: n.data2['往返'] || 0,
          transport_rate2: this.$d(this.$d(n.data2['往返']).div(total2).times(100).toFixed(2)).toString(),
          total: total1,
        };
      });
      this.detail_header = [
        { title: "线路", dataIndex: "line", scopedSlots: { customRender: "line" }, align: "center", width: 120 },
        ...(detail_list.some(n => !!n.weight_5) ? [
          { title: "5吨", dataIndex: "weight_5", scopedSlots: { customRender: "weight_5" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_8) ? [
          { title: "8吨", dataIndex: "weight_8", scopedSlots: { customRender: "weight_8" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_12) ? [
          { title: "12吨", dataIndex: "weight_12", scopedSlots: { customRender: "weight_12" }, align: "center", width: 80 },
        ] : []),
        ...(this.detail_list.some(n => !!n.weight_15) ? [
          { title: "15吨", dataIndex: "weight_15", scopedSlots: { customRender: "weight_15" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_20) ? [
          { title: "20吨", dataIndex: "weight_20", scopedSlots: { customRender: "weight_20" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_25) ? [
          { title: "25吨", dataIndex: "weight_25", scopedSlots: { customRender: "weight_25" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_30) ? [
          { title: "30吨", dataIndex: "weight_30", scopedSlots: { customRender: "weight_30" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_35) ? [
          { title: "35吨", dataIndex: "weight_35", scopedSlots: { customRender: "weight_35" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_40) ? [
          { title: "40吨", dataIndex: "weight_40", scopedSlots: { customRender: "weight_40" }, align: "center", width: 80 },
        ] : []),
        ...(detail_list.some(n => !!n.weight_undefined) ? [
          { title: "未匹配", dataIndex: "weight_undefined", scopedSlots: { customRender: "weight_undefined" }, align: "center", width: 80 },
        ] : []),
        { title: "任务占比(单程/往返)", dataIndex: "transport_kind", scopedSlots: { customRender: "transport_kind" }, align: "center", width: 160 },
        { title: "合计", dataIndex: "total", scopedSlots: { customRender: "total" }, align: "center", width: 80 },
      ];
      this.detail_list = [
        {
          line: "合计",
          weight_5,
          weight_8,
          weight_12,
          rate_12: weight_12 ? this.$d(this.$d(weight_12).div(_total).times(100).toFixed(2)).toString() : '',
          weight_15,
          weight_20,
          weight_25,
          weight_30,
          rate_30: weight_30 ? this.$d(this.$d(weight_30).div(_total).times(100).toFixed(2)).toString() : '',
          weight_35,
          weight_40,
          weight_undefined,
          transport_kind1,
          transport_rate1: transport_kind1 ? this.$d(this.$d(transport_kind1).div(total_).times(100).toFixed(2)).toString() : '',
          transport_kind2,
          transport_rate2: transport_kind2 ? this.$d(this.$d(transport_kind2).div(total_).times(100).toFixed(2)).toString() : '',
          total: _total,
        },
        ...detail_list.sort((a, b) => b.total - a.total),
      ];
    },
    openDispatchDetail() {
      this.$toast.loading({ message: "" });
      //发车数据表已恢复旧逻辑（始终以昨天为基准），详情同样按旧逻辑传当天日期
      this.$api.doAPI("/statistics/dispatchDetail", {
        date: this.$moment().format("YYYY-MM-DD"),
        province: this.tab,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.makedispatchDetail(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch(() => {
        this.$toast.clear();
      });
    },
    makedispatchDetail(payload) {
      const dates = (payload && payload.dates) || [];
      const lines = (payload && payload.lines) || [];
      this.dispatchDetailHeaders = [
        { title: "线路名称", dataIndex: "name", scopedSlots: { customRender: "name" }, align: "center", width: 180 },
        ...dates.map((d) => ({
          title: d,
          dataIndex: `day_${d}`,
          scopedSlots: { customRender: `day_${d}` },
          align: "center",
          width: 120,
        })),
      ];
      this.dispatchDetailRows = lines.map((row, idx) => {
        const item = { _id: `line_${idx}_${row.line}`, name: row.line };
        dates.forEach((d) => {
          item[`day_${d}`] = this.formatWeightCell(row.counts && row.counts[d]);
        });
        return item;
      });
      // 合计行：两吨位分别累加
      const dayTotals = dates.reduce((acc, d) => {
        acc[d] = lines.reduce(
          (sum, row) => {
            const cell = (row.counts && row.counts[d]) || null;
            sum.w12 += Number(cell && cell.weight_12) || 0;
            sum.w30 += Number(cell && cell.weight_30) || 0;
            return sum;
          },
          { w12: 0, w30: 0 }
        );
        return acc;
      }, {});
      const summaryRow = {
        _id: 'summary',
        _isSummary: true,
        name: '合计',
      };
      dates.forEach((d) => {
        const t = dayTotals[d];
        summaryRow[`day_${d}`] = `${t.w12}|${t.w30}`;
      });
      this.dispatchDetailRows = [summaryRow, ...this.dispatchDetailRows];
      this.mockLineCount = lines.length;
      this.dispatchDetailOpen = true;
    },
    // 单元格格式化: weight_12|weight_30(空吨位补 0)
    formatWeightCell(cell) {
      if (!cell) return '0|0';
      const w12 = Number(cell.weight_12) || 0;
      const w30 = Number(cell.weight_30) || 0;
      return `${w12}|${w30}`;
    },
    showdetail1(item) {
      console.log('showdetail1', item);
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/showdetail1", {
        // 列表数字来自 StatisticsDay 预聚合, 其统计窗口为 [所选日期08:00, 次日08:00);
        // 而后端 showdetail1 的窗口为 [传入日期前一天08:00, 传入日期08:00),
        // 因此这里传 所选日期+1天, 两侧窗口才对齐(与旧逻辑传"今天"的效果一致)
        date: this.$moment(this.date).add(1, "days").format("YYYY-MM-DD"),
        dispatch_post_office: item.dispatch_post_office,
        dispatch_post_offices: item.dispatch_post_offices,
        province: this.tab,
      }).then((res) => {
        console.log(res);
        this.$toast.clear();
        if (res.code === 0) {
          this.makedetaillist(res.data.data);
          this.detail_model = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
    showdetail2(item) {
      console.log('showdetail2', item);
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/statistics/showdetail2", {
        date: this.date,
        dispatch_post_office: item.dispatch_post_office,
        dispatch_post_offices: item.dispatch_post_offices,
        province: this.tab,
      }).then((res) => {
        console.log(res);
        this.$toast.clear();
        if (res.code === 0) {
          this.makedetaillist(res.data.data);
          this.detail_model = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
    showdetail3(item) {
      console.log('showdetail3', item);
      this.$toast.loading({ message: "" });
      //运行情况表已恢复旧逻辑（始终以昨天为基准），详情同样按旧逻辑传当天日期
      this.$api.doAPI("/statistics/showdetail3", {
        date: this.$moment().format("YYYY-MM-DD"), title: item.title,
        province: this.tab,
      }).then((res) => {
        console.log(res);
        if (res.code === 0) {
          this.$api.doAPI("/waybill/list", { temp_download_id: res.data._id, action: 'download' }).then((res) => {
            this.$toast.clear();
            // console.log(res);
            if (res.code === 0) {
              this.$download(res.data.url, res.data.name);
            }
            else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        }
        else {
          this.$toast.clear();
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
    showdetail4(item) {
      console.log('showdetail4', item);
      this.$toast.loading({ message: "" });
      //运行情况表已恢复旧逻辑（始终以昨天为基准），详情同样按旧逻辑传当天日期
      this.$api.doAPI("/statistics/showdetail4", {
        date: this.$moment().format("YYYY-MM-DD"), title: item.title,
        province: this.tab,
      }).then((res) => {
        console.log(res);
        if (res.code === 0) {
          this.$api.doAPI("/waybill/list", { temp_download_id: res.data._id, action: 'download' }).then((res) => {
            this.$toast.clear();
            // console.log(res);
            if (res.code === 0) {
              this.$download(res.data.url, res.data.name);
            }
            else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        }
        else {
          this.$toast.clear();
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}

.t-title {
  padding: 0 20px;
}


// 本月运费卡片 hover 提示
/deep/ .kpi-card-clickable {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

/deep/ .kpi-card-clickable:hover {
  box-shadow: 0 4px 14px rgba(211, 47, 47, 0.25) !important;
  transform: translateY(-1px);
}

// 昨日发车/本月发车卡片 hover 提示（中性阴影，适配蓝/橙图标卡）
/deep/ .kpi-card-link {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

/deep/ .kpi-card-link:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px);
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

.dispatch-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32px;
}

.dispatch-cell-num {
  font-weight: 600;
  color: #37474f;
  font-family: Consolas, "Courier New", monospace;
  letter-spacing: 0.5px;
}

.dispatch-cell-empty {
  color: #bdbdbd;
}

.dispatch-cell-name {
  font-weight: 500;
  color: #37474f;
}

.dispatch-cell-summary {
  font-weight: 700;
  color: #37474f;
  font-family: Consolas, "Courier New", monospace;
  letter-spacing: 0.5px;
  font-size: 15px;
}

/deep/ .dispatch-detail-table .ant-table-tbody>tr.summary-row>td {

  border-top: 2px solid #1976d2 !important;
}

/deep/ .dispatch-detail-table .ant-table-thead>tr>th {
  background: #1976d2 !important;
  color: #fff !important;
  font-weight: 600;
  text-align: center;
}

/deep/ .dispatch-detail-table .ant-table-tbody>tr:hover>td {
  background: #e3f2fd !important;
}

/* 本月运费明细 - 利润正负色 */
.text-positive {
  color: #2E7D32 !important;
  font-weight: 600;
}

.text-negative {
  color: #C62828 !important;
  font-weight: 600;
}

/* 本月运费明细 - 合计行 */
.month-detail-footer {

  padding: 10px 0;
  display: flex;
  font-weight: bold;
  border-top: 2px solid #d32f2f;
}

/deep/ .month-detail-table .ant-table-tbody>tr.summary-row>td {
  border-top: 2px solid #d32f2f !important;

  font-weight: bold;
}

/* 标段单元格：收入/成本/利润 三段竖排 */
.freight-cell {
  display: block;
  font-family: Consolas, "Courier New", monospace;
  font-size: 12px;
  line-height: 1.6;
  font-weight: 600;
}

.freight-income {
  color: #008FFB;
}

.freight-cost {
  color: #00A86B;
}

/* 宽度自适应：数字过长时缩小显示不溢出 */
/deep/ .month-detail-table .ant-table-tbody>tr>td,
/deep/ .month-detail-table .ant-table-thead>tr>th {
  padding: 6px 4px !important;
  word-break: break-all;
}
</style>